export const OPEN_CALL_RECORDING_DELETE_MODAL = 'OPEN_CALL_RECORDING_DELETE_MODAL';
export const DELETE_CALL_RECORDING = 'DELETE_CALL_RECORDING';
export const OPEN_CALL_VOICEMAIL_DELETE_MODAL = 'OPEN_CALL_VOICEMAIL_DELETE_MODAL';